import React, { Component } from 'react';
import { connect } from 'react-redux';
import subtotalFeesAndCredit from '../../selectors/subtotalFeesAndCredit.selector';
import TextInput from '../../components/TextInput';

class SubtotalFeesCredit extends Component {
  render() {
    const { subtotal } = this.props;
    return (
      <div className="Row Row-paddedBottom">
        <TextInput tabIndex="-1" className="Row-subtotal" id="Rsubsub" tooltip="Subtotal of reg fee minus credit" value={subtotal} readOnly />
        <label tabIndex="-1" className="Row-totalHeadingLabel" htmlFor="Rsubsub" data-tooltip="Subtotal of Registration fees minus credit">SUBTOTAL <span className="Row-subtext no-print">(Fees + allowed credit)</span></label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subtotal: subtotalFeesAndCredit(state),
  };
};

export default connect(mapStateToProps)(SubtotalFeesCredit);
